import { ReadonlyArray, Runtime, flow } from "fp";
import { QueryKey } from "react-query";

import {Cache, Reference, Store } from "~/Data";
import { Request } from "~/Request";

import * as WorkCode from "~/WorkCode";

export namespace Get {
  /** [API Documentation](TODO) */
  export const request = (
    companyID: string
  ): Store.Request<WorkCode.WorkCode> =>
    flow(
      Request.fromConfig({
        endpoint: `/time-tracking/organizations/${companyID}/work-codes`,
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(WorkCode.Response.runtime())),
      Request.onSuccess(
        Cache.fromList(
          flow(WorkCode.Response.decode, (workCode) => [workCode.id, workCode])
        )
      )
    );
}

export namespace Query {

  export type QueryIdParams = {
    readonly company: Reference.Reference;
    readonly job?: Reference.Reference;
  };

  export const key = ({ company, job }: QueryIdParams): QueryKey => [
    "Work Codes",
    `company:${company.id}${job ? `-job:${job.id}`: ""}`,
  ];

  export const request = ({
    company,
    job,
  }: QueryIdParams): Request.Fn<readonly WorkCode.WorkCode[]> =>
    flow(
      Request.fromConfig({
        endpoint: `/time-tracking/organizations/${company.id}/work-codes${job ? `?job_id=${job.id}` : ""}`,
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(WorkCode.Response.runtime())),
      Request.onSuccess(ReadonlyArray.map((workCode) => WorkCode.Response.decode(workCode)))
    );
}
